import {useEffect, useRef, useState} from "react";
import http from "../services/api/utilities/http";

export const usePost = (method, url, payload, execute) => {
    const [data, setData] = useState()
    const [error, setError] = useState(false)
    const [isSending, setIsSending] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const isMounted = useRef(true)

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    useEffect(() => {
        if (isSending || !execute) return

        setIsSending(true)

        http({
            method,
            url,          // url باید relative باشه مثل: "/data_connector/..."
            data: payload,
        })
            .then((res) => {
                setError(false);
                setData(res.data.data);
                setIsSuccess(true);
                if (isMounted.current) setIsSending(false);
            })
            .catch((err) => {
                console.log(err);
                setError(err);
                setIsSuccess(false);
                if (isMounted.current) setIsSending(false);
            });

    }, [execute])

    const status = {
        isSuccess,
        isSending,
        isError: !!error,
    }

    return {
        data,
        status,
    }
};